export default __webpack_public_path__ + "static/media/connects2.c9c30364.png";